import { render } from "./PhotoSphereViewer.vue?vue&type=template&id=71fc032f&scoped=true&ts=true"
import script from "./PhotoSphereViewer.vue?vue&type=script&lang=ts"
export * from "./PhotoSphereViewer.vue?vue&type=script&lang=ts"

import "./PhotoSphereViewer.vue?vue&type=style&index=0&id=71fc032f&scoped=true&lang=css"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fc032f"]])

export default __exports__